import { atom } from 'jotai';

/**
 * HomeAtomic 단위의 공용 query parameter 상태
 * key: screenName, value: query params (동적 key-value)
 *
 * @example
 * {
 *   "HOME_TODAY": { "category_sno": "123" },
 *   "HOME_BEAUTY": { "category_sno": "456" }
 * }
 */
export const atomicStateAtom = atom<
  Record<string, Record<string, string | null>>
>({});
